import { render } from "./record-stream.vue?vue&type=template&id=cdcdc336&ts=true"
import script from "./record-stream.vue?vue&type=script&lang=ts"
export * from "./record-stream.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__